import * as dateformat from "dateformat";

export function formatDate(value: string | Date | number): string {
    if (!value) {
        return "";
    }
    const date = new Date(value);

    if (!date || isNaN(date.getTime())) {
        return "";
    }

    return dateformat(date, "yyyy-mm-dd");
}
